<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { normalizeEntityTagColor } from '~/lib/entityTags';

const props = withDefaults(defineProps<{
    modelValue?: string;
    label?: string;
    disabled?: boolean;
}>(), {
    modelValue: '#64748b',
    label: 'Choose colour',
    disabled: false,
});

const emit = defineEmits<{
    'update:modelValue': [value: string];
}>();

const input = ref<HTMLInputElement | null>(null);
const color = computed(() => normalizeEntityTagColor(props.modelValue));

function chooseColor() {
    if (!props.disabled) input.value?.click();
}

function updateColor(event: Event) {
    emit('update:modelValue', normalizeEntityTagColor((event.target as HTMLInputElement).value));
}
</script>

<template>
    <div class="relative inline-flex shrink-0">
        <Button
            type="button"
            variant="outline"
            size="sm"
            class="h-8 gap-2 px-2"
            :aria-label="label"
            :disabled="disabled"
            @click="chooseColor"
        >
            <span
                class="size-4 rounded-sm border border-border shadow-xs"
                :style="{ backgroundColor: color }"
                aria-hidden="true"
            />
            <span class="font-mono text-[11px] uppercase text-muted-foreground">{{ color }}</span>
        </Button>
        <input
            ref="input"
            :value="color"
            type="color"
            class="sr-only"
            tabindex="-1"
            :aria-label="label"
            :disabled="disabled"
            @input="updateColor"
        >
    </div>
</template>
